import React, { Component, Fragment } from 'react';
import { DisplayComponent } from 'formlabs-web-components/BaseComponents';
import Script from 'react-load-script';
import { Helmet } from 'react-helmet';

const storageKey = 'DashboardVersion';
const noVersion = 'noVersion';

const DashboardPage = DisplayComponent(
  class DashboardPage extends Component {
    constructor(props) {
      super(props);
      this.state = {
        version: ''
      };
    }

    componentDidMount() {
      const currentVersion =
        window.localStorage.getItem(storageKey) || noVersion;
      this.setState({
        version: currentVersion
      });
      this.getAndCompareDashboardVersion(currentVersion);
    }

    getAndCompareDashboardVersion(currentVersion) {
      fetch('/static/dashboard/meta.json')
        .then(response => response.json())
        .then(meta => {
          const version = meta.version;
          if (version !== currentVersion && version !== noVersion) {
            window.localStorage.setItem(storageKey, version);
            if (currentVersion !== noVersion) {
              window.location.reload();
            }
          }
        })
        .catch(err => {
          console.log(`Error retrieving dashboard version: ${err}`);
        });
    }

    appendVersion(assetUrlPaths) {
      if (this.state.version !== '' && this.state.version !== noVersion) {
        assetUrlPaths.js += `?version=${this.state.version}`;
        assetUrlPaths.css += `?version=${this.state.version}`;
        assetUrlPaths.cmsBaseCss += `?version=${this.state.version}`;
      }
      return assetUrlPaths;
    }

    render() {
      // Waiting for componentDidMount before rendering script
      if (this.state.version === '') {
        return null;
      }
      // Use Razzle URLs by default
      let assetUrlPaths = {
        js: '/static/dashboard/js/main.js',
        css: '/static/dashboard/stylesheets/dashboard.css',
        cmsBaseCss: '/static/dashboard/stylesheets/dashboard-cms-base.css'
      };
      if (process.env.RAZZLE_content_api_uri_base === '') {
        // Use Django URLs for local dev using the Django CMS editor
        assetUrlPaths = {
          js: '/static/formlabs-web/public/cms-dashboard/js/main.js',
          css:
            '/static/formlabs-web/public/cms-dashboard/stylesheets/dashboard.css',
          cmsBaseCss:
            '/static/formlabs-web/public/cms-dashboard/stylesheets/dashboard-cms-base.css'
        };
      } else {
        assetUrlPaths = this.appendVersion(assetUrlPaths);
      }
      return (
        <Fragment>
          <Helmet>
            <title>Dashboard | Formlabs</title>
            <link rel="stylesheet" href={assetUrlPaths.css} />
            <link rel="stylesheet" href={assetUrlPaths.cmsBaseCss} />
            <body data-dashboard="true" />
          </Helmet>
          <div id="content">
            <div id="app-container" />
          </div>
          <Script url={assetUrlPaths.js} />
        </Fragment>
      );
    }
  }
);

export default DashboardPage;
